import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import ReceiptItem from 'components/common/receipt/receipt_item';
import { toCurrencyWithMinorUnitAmount } from 'utilities/currency';

/**
 * Renders the recurring "Hardware services" (rental subscription) section shown
 * on the cart and checkout order summaries. Data comes from the
 * `hardware_rental_summary` field emitted by Sq::OrderSummarySerializer.
 *
 * Renders nothing when the order has no rental items. Callers own the
 * surrounding container/divider so the section matches each page's styling.
 */
const HardwareRentalSection = ({ hardwareRentalSummary }) => {
  const { t } = useTranslation();

  if (!(hardwareRentalSummary?.items?.length > 0)) {
    return null;
  }

  return (
    <>
      <Box mb={2}>
        <b className="semibold-20">
          {t('checkout.receipt.label.hardwareServices').toUpperCase()}
        </b>
      </Box>
      {hardwareRentalSummary.items.map((item) => (
        <ReceiptItem
          key={item.plan_token}
          label={`${item.quantity} x ${item.label}`}
          override={t('checkout.receipt.label.perMonthShort', {
            amount: toCurrencyWithMinorUnitAmount(
              item.monthly_amount.amount,
              item.monthly_amount.currency,
            ),
          })}
        />
      ))}
      <Box mt={2}>
        <p className="paragraph-20">
          {t('checkout.receipt.hardwareRentalAdditionalPreTaxNotice')}
        </p>
      </Box>
    </>
  );
};

export default HardwareRentalSection;
